<template>
  <b-card class="no-border">
    <b-input-group class="mb-2">
      <multiselect
        v-model="selectedReport"
        :options="reports"
        label="title"
        track-by="name"
        placeholder="Select report">
        <template slot="option" slot-scope="props">
          <i v-if="props.option.iconClass" :class="props.option.iconClass"></i> {{props.option.title}}
        </template>
      </multiselect>
    </b-input-group>
    <b-form v-if="selectedReport" @submit.prevent="submitReport(true)" class="mb-2 clearfix">
      <template v-for="opt in options">
        <date-time-range
          v-if="opt.type === 'DATE_TIME_RANGE'"
          :name="opt.key"
          @change="update_datetimerange"
          :key="opt.key"></date-time-range>
        <date-range
          v-if="opt.type === 'DATE_RANGE'"
          :name="opt.key"
          @change="update_daterange"
          :key="opt.key"></date-range>
        <div
          class="mb-3"
          v-if="opt.type === 'MULTISELECT.VEHICLE'"
          :key="opt.key">
          <div class="form-row">
            <div class="form-group col-md">
              <label for="">Vehicle</label>
              <!-- <base-multiselect
                :name="opt.key"
                :options="vehicles"
                :multiple="true"
                :label="'reg_no'"
                :track-by="'id'"
                :placeholder="'Select Vehicle'"
                @input-value="selectVehicle"
              ></base-multiselect> -->
              <br>
              <multiselect
                :name="opt.key"
                v-model="selectedVehicle"
                :options="optionVehicles"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :placeholder="'Search Vehicle'"
                :label="'reg_no'"
                :track-by="'id'"
                :group-values="'vehicles'"
                :group-label="'all'"
                :group-select="true"
              >
              </multiselect>
            </div>
          </div>
        </div>
        <div
          class="mb-3"
          v-if="opt.type === 'MULTISELECT.COMPANY'"
          :key="opt.key">
          <div class="form-row">
            <div class="form-group col-md">
              <label for="">Customer</label>
              <!-- <base-multiselect
                :name="opt.key"
                :options="companies"
                :multiple="true"
                :label="'name'"
                :placeholder="'Select Company'"
                :track-by="'id'"
                :searchable="true"
                :internalSearch="true"
                @input-value="selectCompany"
              ></base-multiselect> -->
              <multiselect
                :name="opt.key"
                v-model="selectedCompany"
                :options="optionCompanies"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :placeholder="'Search Company'"
                :label="'name'"
                :track-by="'id'"
                :group-values="'companies'"
                :group-label="'all'"
                :group-select="true"
              >
              </multiselect>
            </div>
          </div>
        </div>
      </template>
      <div class="clearfix">
        <div class="reports-progress pull-left">
          <report-progress
            v-for="file in onProcess"
            @dismiss="removeOnProgressReport(file.job_id)"
            :state="file.state"
            :url="file.file_url"
            :key="file.job_id"></report-progress>
        </div>
        <div class="pull-right">
          <b-button variant="outline-warning" class="mr-2" @click="onResetForm()">Reset form</b-button>
          <b-dropdown variant="secondary" class="mr-2">
            <span slot="button-content"><i class="fa fa-file-o"></i> Export as</span>
            <b-dropdown-item @click="onExport('XLSX')">Spreadsheet</b-dropdown-item>
            <b-dropdown-item @click="onExport('CSV')">CSV</b-dropdown-item>
            <!-- <b-dropdown-item @click="onExport('PDF')">PDF</b-dropdown-item> -->
          </b-dropdown>
          <b-button type="submit" variant="primary">
            <i class="fa fa-refresh" :class="{'fa-spin': isLoading}"></i> Generate
          </b-button>
        </div>
      </div>
    </b-form>
    <hr/>
    <base-tab
      v-if="hasTabs && selectedReport"
      :name="tabsType"
      :tabs="tabs"
      :activeTab="formData.tab_selected"
      :merge="formData.merge_tab"
      @tab-change="changeSelectedTab"
      @tab-merge="changeMergeTab">
    </base-tab>
    <div v-if="totalRows > 0 || onFilter">
      <b-row class="justify-content-md-center">
        <b-col>
          <b-pagination class="mb-2 pull-right" align="center" size="md" :total-rows="totalRows" v-model="currentPage" :per-page="perPage"> </b-pagination>
        </b-col>
        <b-col col lg="5">
          <b-form-group class="mb-2">
            <b-form-select id="perpage-top" class="w-25 pull-right" :options="pageOptions" v-model="currentPerPage" />
            <label class="pull-right mr-2 mt-2" for="perpage-top">Perpage :</label>
          </b-form-group>
        </b-col>
      </b-row>
      <base-table
        @sort-changed="updateSort"
        @on-filter="filterTable"
        :responsive="true"
        :onLoading="isLoading"
        :items="tableItems"
        :reset="resetTable"
        :fields="tableFields"></base-table>
      <b-row class="justify-content-md-center">
        <b-col>
          <b-pagination class="mt-3 pull-right" align="center" size="md" :total-rows="totalRows" v-model="currentPage" :per-page="perPage"> </b-pagination>
        </b-col>
        <b-col col lg="5">
          <b-form-group class="mb-0 mt-3">
            <b-form-select id="perpage-bottom" class="w-25 pull-right" :options="pageOptions" v-model="currentPerPage" />
            <label class="pull-right mr-2 mt-2" for="perpage-bottom">Perpage :</label>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>
<style lang="sass">
@import "~vue-multiselect/dist/vue-multiselect.min"
.reports-progress
  min-width: 250px
</style>
<script>
import Multiselect from 'vue-multiselect';

import { parse } from 'date-fns';
import DateTimeRange from '@/components/report_options/DateTimeRange';
import DateRange from '@/components/report_options/DateRange';
import BaseMultiselect from '@/components/BaseMultiselect';
import BaseTable from '@/components/BaseTable';
import BaseTab from '@/components/BaseTab';
import ReportProgress from '@/components/ReportProgress';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import includes from 'lodash/includes';

export default {
  components: {
    Multiselect,
    DateTimeRange,
    DateRange,
    BaseTable,
    BaseMultiselect,
    BaseTab,
    ReportProgress,
  },
  data() {
    return {
      selectedVehicle: [],
      selectedCompany: [],
      isLoading: false,
      activeTab: 1,
      mergeTab: false,
      selectedReport: null,
      formData: {
        merge_tab: false,
        tab_selected: null,
      },
      resetTable: 0,
      options: [],
      currentPage: 1,
      currentPerPage: 20,
      pageOptions: [20, 50, 100],
      filteredField: [],
      exportReportResult: false,
      download: {
        progress: 0,
        result: '',
      },
      onProgressTimer: 0,
    };
  },
  created() {
    this.$store.commit('reports/CLEAR_RESULT_TOTAL');
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'report', name: 'Reports' },
    ]);
    this.$store.dispatch('reports/LOAD_DATA');
    this.$store.dispatch('vehicles/LOAD_INFO').then(() => {
      this.$store.commit('vehicles/SET_QUERY_COUNT', this.vehicle_count_all);
      this.$store.dispatch('vehicles/LOAD_DATA');
    });
    this.$store.dispatch('companies/LOAD_INFO').then(() => {
      this.$store.commit('companies/SET_QUERY_COUNT', this.company_count_all);
      this.$store.dispatch('companies/LOAD_DATA');
    });
  },
  mounted() {
    this.reloadOnProcessReport(true, false);
  },
  beforeDestroy() {
    clearTimeout(this.onProgressTimer);
  },
  computed: {
    reports() {
      const reports = this.$store.getters['reports/reports'];
      return reports.filter((report) => {
        const namespace = get(report, 'namespace', []);
        if (isEmpty(namespace)) return true;
        return includes(namespace, this.$store.getters.userData.company.namespace);
      });
    },
    onProcess() {
      return this.$store.getters['report_files/onProcess'];
    },
    vehicles() {
      return this.$store.getters['vehicles/vehicles'];
    },
    optionVehicles() {
      const filter = this.vehicles.map(dt => ({
        id: dt.id,
        reg_no: dt.reg_no,
        gps_devices: dt.gps_devices,
        driver: dt.driver,
        company: dt.company,
        created_at: dt.created_at,
      }));
      const listVehicle = [{
        all: 'Select All Vehicle',
        vehicles: filter,
      }];
      return listVehicle;
    },
    optionCompanies() {
      const filter = this.companies.map(dt => ({
        active: dt.active,
        id: dt.id,
        metadata: dt.metadata,
        name: dt.name,
        namespace: dt.namespace,
        created_at: dt.created_at,
        parent: dt.parent,
      }));
      const listCompany = [{
        all: 'Select All Company',
        companies: filter,
      }];
      return listCompany;
    },
    vehicle_count_all() {
      return this.$store.getters['vehicles/count_all'];
    },
    companies() {
      return this.$store.getters['companies/companies'];
    },
    company_count_all() {
      return this.$store.getters['companies/count_all'];
    },
    tableFields() {
      return this.$store.getters['reports/tableFields'];
    },
    tableItems() {
      return this.$store.getters['reports/tableItems'];
    },
    totalRows() {
      return this.$store.getters['reports/resultTotal'];
    },
    perPage() {
      return this.$store.getters['reports/resultPageCount'];
    },
    onFilter() {
      const { filteredField } = this;
      return !isEmpty(filteredField);
    },
    tabs() {
      return this.$store.getters['reports/resultTabs'];
    },
    hasTabs() {
      return !isEmpty(this.tabs);
    },
    tabsType() {
      const options = this.options.map(v => v.key);
      const isVehicleTab = options.indexOf('vehicles') !== -1;
      const isCompanyTab = options.indexOf('companies') !== -1;
      let type = 'tab';

      if (isVehicleTab) {
        type = 'vehicle';
      } else if (isCompanyTab) {
        type = 'company';
      }

      return type;
    },
  },
  watch: {
    reports(reportList) {
      const { reportName } = this.$route.params;

      if (reportName) {
        this.selectedReport = reportList.find(a => a.name === reportName);
      }
    },
    selectedVehicle(value) {
      this.formData.vehicle_ids = isEmpty(value) ? [] : value.map(v => parseInt(v.id, 10));
    },
    selectedCompany(value) {
      this.formData.customer_ids = isEmpty(value) ? [] : value.map(v => parseInt(v.id, 10));
    },
    selectedReport(sel) {
      if (typeof sel === 'object' && sel) {
        this.$store.commit('SET_BREADCRUMB_ITEMS', [
          { to: '', name: 'Home' },
          { to: 'report', name: 'Reports' },
          { to: sel.name, name: sel.title },
        ]);
        this.options.splice(0);
        for (let i = 0; i < sel.options.length; i++) {
          const opt = sel.options[i];
          this.options.push(opt);
        }
        this.$store.commit('reports/SELECT_REPORT', sel.name);
      }
    },
    fv_daterange_start(val) {
      if (val) {
        const date = parse(val);
        this.$set(this.formConfig.dateRange.end, 'minDate', date);
      }
    },
    fv_daterange_end(val) {
      if (val) {
        const date = parse(val);
        this.$set(this.formConfig.dateRange.start, 'maxDate', date);
      }
    },
    currentPage(pageNumber) {
      if (this.isLoading) { return; }
      this.$store.commit('reports/SET_QUERY_PAGE_NUMBER', pageNumber);
      this.submitReport();
    },
    currentPerPage(count) {
      if (this.isLoading) { return; }
      this.$store.commit('reports/SET_RESULT_PAGE_COUNT', count);
      this.$store.commit('reports/SET_QUERY_PAGE_COUNT', count);
      const isCurrentPageNotAva = Math.ceil(this.totalRows / count) < this.currentPage;
      if (!isCurrentPageNotAva) this.submitReport();
    },
  },
  methods: {
    update_datetimerange(name, value) {
      this.formData[name] = value;
    },
    update_daterange(name, value) {
      this.formData[name] = value;
    },
    submitReport(refresh = false) {
      if (this.isLoading) { return; }
      this.isLoading = true;
      if (refresh) {
        this.formData.requestId = Date.now();
        this.formData.tab_selected = null;
        this.resetTable = this.formData.requestId;
        /* TODO: How to do this correctly? */
        this.currentPage = 1;
        this.$store.commit('reports/SET_QUERY_PAGE_NUMBER', 1);
        this.$store.commit('reports/CLEAR_QUERY_SORT_FILTER');
        this.filteredField.splice(0);
      }
      this.$store.dispatch('reports/LOAD_REPORT_DATA', this.formData).then((loaded) => {
        this.isLoading = !loaded;
      });
    },
    updateSort(sort) {
      if (this.isLoading) { return; }
      this.$store.commit('reports/SET_QUERY_SORT', sort);
      this.submitReport();
    },
    filterTable(filter) {
      if (this.isLoading) { return; }
      this.filteredField = [];

      /* eslint-disable */
      for (const k in filter) {
        if (filter.hasOwnProperty(k)) {
          const el = filter[k];
          if (el.trim() !== '') {
            this.filteredField.push(k);
          }
        }
      }
      /* eslint-enable */
      this.$store.commit('reports/SET_QUERY_FILTER', filter);
      this.submitReport();
    },
    // selectVehicle({ name, value: vehicles }) {
    //   this.formData[name] = isEmpty(vehicles) ? [] : vehicles.map(v => parseInt(v.id, 10));
    // },
    // selectCompany({ name, value: companies }) {
    //   this.formData[name] = isEmpty(companies) ? [] : companies.map(v => parseInt(v.id, 10));
    // },
    changeSelectedTab(tabIndex) {
      if (this.isLoading) { return; }
      this.formData.tab_selected = tabIndex;
      this.submitReport();
    },
    changeMergeTab(setMerge) {
      if (this.isLoading) { return; }
      this.formData.merge_tab = setMerge;
      this.submitReport();
    },
    onExport(format = 'XLSX') {
      this.$store.commit('reports/SET_REPORT_FORMAT', format);
      this.$store.dispatch('reports/EXPORT_REPORT_DATA', this.formData).then(({ result }) => {
        const { job_id } = result;

        this.exportReportResult = typeof job_id === 'string';
        this.$store.commit('report_files/ADD_ON_PROCESS_DATA', {
          job_id,
          state: 'PROCESSING',
        });
        this.reloadOnProcessReport(true);
      });
    },
    getOnProcess() {
      const onProgressStates = [
        'PROCESSING',
        'COLLECTING_DATA',
        'EXPORTING',
      ];
      return this.onProcess.filter(p => onProgressStates.indexOf(p.state) > -1);
    },
    reloadOnProcessReport(force = false, onProcessOnly = true) {
      this.onProgressTimer = setTimeout(() => {
        if (force || this.getOnProcess().length > 0) {
          this.$store.dispatch('report_files/LOAD_ON_PROCESS_REPORT', onProcessOnly).then((total) => {
            if (total === 0 && this.getOnProcess().length > 0) {
              this.reloadOnProcessReport(false, false);
            } else {
              this.reloadOnProcessReport();
            }
          });
        } else {
          this.reloadOnProcessReport();
        }
      }, 2e3);
    },
    removeOnProgressReport(jobId) {
      this.$store.dispatch('report_files/DELETE_ON_PROCESS_REPORT', jobId);
    },
    onResetForm() {
      this.isLoading = false;
      this.activeTab = 1;
      this.mergeTab = false;
      this.selectedReport = null;
      this.formData = {
        merge_tab: false,
        tab_selected: null,
      };
      this.resetTable = 0;
      this.options = [];
      this.currentPage = 1;
      this.currentPerPage = 20;
      this.pageOptions = [20, 50, 100];
      this.filteredField = [];
      this.download = {
        progress: 0,
        result: '',
      };
      this.onProgressTimer = 0;
      this.$store.commit('reports/CLEAR_TABLE_ITEM');
      this.$store.commit('reports/CLEAR_TABLE_FIELD');
      this.$store.commit('reports/CLEAR_QUERY_SORT_FILTER');
      this.$store.commit('reports/CLEAR_QUERY_FILTER');
      this.$store.commit('reports/CLEAR_RESULT_TOTAL');
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/pages/report/Index.vue